import src from "IMAGE";
export default { src, width: 964, height: 300, blurWidth: 0, blurHeight: 0};
